import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ResolutionVocabularyEntry,
  ResolutionVocabularyEntryPost,
  ResolutionVocabularyEntryPut,
} from '../common/ResolutionVocabularyEntry';
import { ApiServiceBase } from './ApiServiceBase';

// Backend #617 B2: BFF pass-through to the resolution-vocabulary curation endpoints
// (carrier-admin only). Writes are validated fail-closed server-side: unknown targets,
// malformed languages and duplicate (subject, term, language) identities answer 400.
@Injectable({
  providedIn: 'root',
})
export class ResolutionVocabularyService extends ApiServiceBase {
  protected readonly path = 'resolutionvocabulary';

  get(subject?: string): Observable<ResolutionVocabularyEntry[]> {
    return this.http
      .get<ResolutionVocabularyEntry[]>(this.getUrl(), {
        params: subject ? { subject } : {},
      });
  }

  // Backend #629: the whole vocabulary as the canonical seed file — the export half of the
  // curation round-trip (curate here → export → commit the file into the backend repo → one
  // seeding boot per environment). Taken as a Blob and passed on untouched: the backend
  // already returns the deterministically sorted, seed-ready bytes, and ANY reshaping here
  // would break the byte-stable round-trip the format exists for.
  export(): Observable<Blob> {
    return this.http
      .get(this.getUrl() + '/export', { responseType: 'blob' });
  }

  create(entry: ResolutionVocabularyEntryPost): Observable<ResolutionVocabularyEntry> {
    return this.http
      .post<ResolutionVocabularyEntry>(this.getUrl(), entry);
  }

  update(id: string, entry: ResolutionVocabularyEntryPut): Observable<ResolutionVocabularyEntry> {
    return this.http
      .put<ResolutionVocabularyEntry>(this.getUrl() + '/' + id, entry);
  }

  // Backend #623: the explicit sign-off on one VAT row. The stamp names the acting human —
  // the BFF forwards the subject s2s — and any later edit clears it again. VAT rows only:
  // category rows answer 400 (they are taxonomy decisions, they need no tax-advisor review).
  verify(id: string): Observable<ResolutionVocabularyEntry> {
    return this.http
      .post<ResolutionVocabularyEntry>(this.getUrl() + '/' + id + '/verify', null);
  }

  delete(id: string): Observable<void> {
    return this.http
      .delete<void>(this.getUrl() + '/' + id);
  }
}
